import * as React from "react";
import {TransitionGroup, CSSTransition} from "react-transition-group";
import {cx} from "emotion";

import "./side-menu.scss";

import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {GlobalKeys}     from "@Common/react/global-keys-react";
import {UseState}       from "@Common/react/use-state";

export const MobileSideMenu = ({renderContent, next}) => cs(
    consumeContext("themeScheme"),
    ["show", (_, next) => UseState({next})],
    ({show}, next) => <GlobalKeys {...{
        keyCombo: "Escape",
        disabled: !show.value,
        onKeyDown: () => show.onChange(false),
        next,
    }}/>,
    ({show, themeScheme}) => (
        <div className={cx("mobile-side-menu-wrapper-23fj89", {"show-menu": show.value})}>
            {next({
                show: (params) => show.onChange({params}),
            })}

            <TransitionGroup>
                {show.value && (
                    <CSSTransition timeout={300} classNames="from-right">
                        <div
                            className="mobile-menu"
                            style={{background: themeScheme.xpresso.menuBackgroundColor}}
                        >

                            <div className="content">
                                {renderContent(show.value.params)}
                            </div>

                            <div
                                className="close-btn"
                                xd-qa-type="icon"
                                xd-qa-name="close"
                                onClick={() => show.onChange(false)}
                                style={{color: themeScheme.xpresso.menuTextColor}}
                            >
                                &times;
                            </div>

                        </div>
                    </CSSTransition>
                )}
            </TransitionGroup>
        </div>
    ),
)